<div class="erstellen-container">

  <!-- HEADER -->
  <div class="page-header">
    <div class="header-left">
      <button mat-icon-button type="button" (click)="zurueck()" matTooltip="Zurück">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div>
        <h1 class="page-title">Leere Inbetriebnahmeliste erstellen</h1>
        <div class="page-sub">
          Ohne Excel – Spalten selbst festlegen oder eine Vorlage verwenden.
          <ng-container *ngIf="projektName"> · Projekt <strong>{{ projektName }}</strong></ng-container>
        </div>
      </div>
    </div>

    <button mat-stroked-button type="button" (click)="zuVorlagen()">
      <mat-icon>view_list</mat-icon>
      Vorlagen verwalten
    </button>
  </div>


  <mat-card class="hint-card" *ngIf="!canEdit">
    <mat-card-content>
      Zum Erstellen einer Liste ist Schreibrecht nötig. Montage und Vorarbeiter können Listen nur lesen.
    </mat-card-content>
  </mat-card>


  <ng-container *ngIf="canEdit">

    <!-- SCHRITT 1: NAME UND ART DER LISTE -->
    <mat-card class="schritt-card">
      <mat-card-content>

        <h2 class="schritt-titel">
          <span class="schritt-nummer">1</span>
          Liste benennen
        </h2>

        <div class="schritt-felder">

          <mat-form-field appearance="outline" class="feld-name">
            <mat-label>Name der Liste</mat-label>
            <input matInput [(ngModel)]="name" maxlength="200" required
              placeholder="z. B. Messstellen Kesselhaus, Verbraucher Halle 3">
            
          </mat-form-field>

          <div class="feld-typ">
            <span class="feld-typ-label">Art der Liste</span>
            <mat-button-toggle-group [(ngModel)]="listenTyp" aria-label="Art der Liste">
              <mat-button-toggle *ngFor="let t of listenTypen" [value]="t.wert">{{ t.text }}</mat-button-toggle>
            </mat-button-toggle-group>
            <span class="feld-typ-hinweis">
              Bestimmt nur die fachlichen Standardfelder (z. B. Messbereich oder Nennleistung). Kategorien,
              Prüfpunkte und Anlagenteile funktionieren für beide gleich.
            </span>
          </div>

        </div>

      </mat-card-content>
    </mat-card>


    <!-- SCHRITT 2: STRUKTUR -->
    <mat-card class="schritt-card">
      <mat-card-content>

        <h2 class="schritt-titel">
          <span class="schritt-nummer">2</span>
          Spaltenstruktur festlegen
        </h2>

        <mat-button-toggle-group class="art-wahl" [(ngModel)]="art" aria-label="Woher kommt die Struktur">
          <mat-button-toggle value="vorlage">
            <mat-icon>content_copy</mat-icon>
            Aus Vorlage erstellen
          </mat-button-toggle>
          <mat-button-toggle value="eigene">
            <mat-icon>tune</mat-icon>
            Benutzerdefinierte Struktur
          </mat-button-toggle>
        </mat-button-toggle-group>


        <!-- ── AUS VORLAGE ── -->
        <div class="art-inhalt" *ngIf="art === 'vorlage'">

          <div class="loading" *ngIf="vorlagenLaden">
            <mat-spinner diameter="32"></mat-spinner>
          </div>

          <p class="art-hinweis fehler-text" *ngIf="vorlagenFehler">{{ vorlagenFehler }}</p>

          <ng-container *ngIf="!vorlagenLaden && !vorlagenFehler">

            <p class="art-hinweis" *ngIf="vorlagen.length === 0">
              Es gibt noch keine Vorlagen. Unter „Benutzerdefinierte Struktur“ lässt sich eine Struktur
              anlegen und dabei als Vorlage speichern.
            </p>

            <ng-container *ngIf="vorlagen.length > 0">

              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="vorlagen-suche"
                *ngIf="vorlagen.length > 5">
                <mat-label>Vorlage suchen</mat-label>
                <input matInput [(ngModel)]="vorlagenSuche" placeholder="Name, Beschreibung oder Spalte">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>

              <div class="vorlagen-grid">
                <button type="button" class="vorlage-kachel" *ngFor="let v of gefilterteVorlagen; trackBy: trackByVorlage"
                  [class.vorlage-kachel-aktiv]="gewaehlteVorlage?.id === v.id" (click)="vorlageWaehlen(v)">

                  <span class="vorlage-kopf">
                    <mat-icon>{{ gewaehlteVorlage?.id === v.id ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
                    <span class="vorlage-name">{{ v.name }}</span>
                  </span>

                  <span class="vorlage-meta">
                    {{ listenTypText(v.listenTyp) }} · {{ v.spaltenCount }} Spalte{{ v.spaltenCount === 1 ? '' : 'n' }}
                    · Kennzeichnung: <strong>{{ kennzeichnungVon(v) }}</strong>
                  </span>

                  <span class="vorlage-beschreibung" *ngIf="v.beschreibung">{{ v.beschreibung }}</span>
                </button>
              </div>

              <p class="art-hinweis" *ngIf="gefilterteVorlagen.length === 0">Keine Vorlage passt zur Suche.</p>


              <!-- Vorschau der gewählten Vorlage -->
              <div class="vorlage-vorschau" *ngIf="gewaehlteVorlage as v">

                <div class="vorschau-kopf">
                  <h3 class="vorschau-titel">Spalten der Vorlage „{{ v.name }}“</h3>
                  <span class="kennz-chip">
                    <mat-icon inline>key</mat-icon>
                    Kennzeichnung: {{ kennzeichnungVon(v) }}
                  </span>
                </div>

                <app-struktur-vorschau [struktur]="v.struktur"></app-struktur-vorschau>

                <p class="art-hinweis">
                  Die neue Liste erhält eine eigene Kopie dieser Struktur. Spätere Änderungen an der Vorlage
                  wirken sich nicht auf die Liste aus.
                </p>
              </div>

            </ng-container>

          </ng-container>

        </div>


        <!-- ── EIGENE STRUKTUR ── -->
        <div class="art-inhalt" *ngIf="art === 'eigene'">

          <p class="art-hinweis">
            Jede Spalte wird zu einem Feld der Messstelle. Genau eine Spalte ist die
            <strong>Kennzeichnung</strong> – z. B. KKS, AKZ, Betriebsmittelkennzeichen oder Gerätenummer.
            Sie ist Pflicht.
          </p>

          <app-struktur-editor [struktur]="eigeneStruktur" [disabled]="speichert"
            (strukturChange)="strukturGeaendert($event)" (gueltigChange)="gueltigkeitGeaendert($event)">
          </app-struktur-editor>

          <div class="vorlage-speichern">
            <mat-checkbox [(ngModel)]="alsVorlageSpeichern" [disabled]="speichert">
              Als Vorlage speichern
            </mat-checkbox>

            <div class="vorlage-speichern-felder" *ngIf="alsVorlageSpeichern">
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>Vorlagenname</mat-label>
                <input matInput [(ngModel)]="vorlagenName" maxlength="200" required
                  placeholder="z. B. Standard Messstellen KKS">
              </mat-form-field>

              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>Beschreibung (optional)</mat-label>
                <input matInput [(ngModel)]="vorlagenBeschreibung" maxlength="1000"
                  placeholder="Wofür eignet sich diese Struktur?">
              </mat-form-field>
            </div>
          </div>

        </div>

      </mat-card-content>
    </mat-card>


    <!-- SCHRITT 3: ERSTELLEN -->
    <mat-card class="schritt-card">
      <mat-card-content>

        <h2 class="schritt-titel">
          <span class="schritt-nummer">3</span>
          Liste erstellen
        </h2>

  

        <div class="pflege-fehler" *ngIf="fehler">
          <mat-icon inline>error_outline</mat-icon> {{ fehler }}
        </div>

        <div class="erstellen-aktionen">
          <button mat-raised-button color="primary" type="button" [disabled]="!kannErstellen" (click)="erstellen()">
            <mat-icon>playlist_add</mat-icon>
            {{ art === 'vorlage' ? 'Liste aus Vorlage erstellen' : 'Leere Liste erstellen' }}
          </button>

          <mat-spinner diameter="22" *ngIf="speichert"></mat-spinner>

          <button mat-button type="button" (click)="zurueck()" [disabled]="speichert">Abbrechen</button>

          <span class="erstellen-hinweis" *ngIf="!nameGueltig">Bitte zuerst einen Namen vergeben.</span>
          <span class="erstellen-hinweis" *ngIf="nameGueltig && art === 'vorlage' && !gewaehlteVorlage && vorlagen.length > 0">
            Bitte eine Vorlage wählen.
          </span>
        </div>

      </mat-card-content>
    </mat-card>

  </ng-container>

</div>
